export const AppConstants = {
  BASE_URL: "https://amr.wegosecure.com/canopy",
  Online: "Online",
  Offline: "Offline",
  Application: "application/json",
  Contant: "application/json",
  AMROne: "amrone",
  AMRTwo: "amrtwo",
};
